import { defineStore } from "pinia";

export const FoodCarStore = defineStore("foodCar", {
    state:()=>{
        return {
            dataList:[]
        }
    }
})